// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__Uk3B2","content":"page_content__y0xK9"};